import { TextField } from "@mui/material";
import styled from "@emotion/styled";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#EB5E70",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#EB5E70",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#EB5E70",
    },
    "&:hover fieldset": {
      borderColor: "#EB5E70",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#EB5E70",
    },
  },
});

export function StyledInput(props: any) {
  return <CssTextField style={{ width: "100%" }} {...props} />;
}

export function StyledInput2(props: any) {
  return <CssTextField {...props} />;
}
